// extracted by mini-css-extract-plugin
module.exports = {"container":"SwitchInput_container__WPfqV","active":"SwitchInput_active__1e75c","switcher":"SwitchInput_switcher__3NNdY"};